import { render, staticRenderFns } from "./pwdLogin.vue?vue&type=template&id=46cfb319&scoped=true"
import script from "./pwdLogin.vue?vue&type=script&lang=js"
export * from "./pwdLogin.vue?vue&type=script&lang=js"
import style0 from "./pwdLogin.vue?vue&type=style&index=0&id=46cfb319&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cfb319",
  null
  
)

export default component.exports